import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TabButton from "../../../../../../../Components/common/TabButton/TabButton";
import NotificationHeader from "../../NotificationHeader";
import MailingConfigs from "./MailingConfigs";
import MailContents from "./MailContent";
import MailRecipients from "./MailRecipients";
import Backdrop from "../../../../../../../Components/UI/Backdrop/Backdrop";

import {
  requestGetMailingConfigs,
  requestUpdateMailingActive,
} from "../../../../../../../store/actions/settingsActions";

import "./styles.scss";

const getDetailNote = (active) => {
  if (active === "Mail Contents") {
    return "This configuration is optional. If no email subject and body are set in this tab, default email subject and body will be used.";
  } else {
    return "";
  }
};

const MailNotification = ({ selectedNotification }) => {
  const dispatch = useDispatch();

  const mailingConfigs = useSelector((state) => state.settings.mailingConfigs);
  const mailingActive = useSelector((state) => state.settings.mailingActive);

  const [active, setActive] = useState("Configs");
  const [isMailingActive, setIsMailingActive] = useState(mailingActive);

  useEffect(() => {
    dispatch(requestGetMailingConfigs());
  }, []);

  useEffect(() => {
    if (
      isMailingActive !== mailingActive &&
      mailingConfigs.server &&
      mailingConfigs.port &&
      mailingConfigs.security &&
      mailingConfigs.senderEmail
    ) {
      dispatch(requestUpdateMailingActive({ active: isMailingActive }));
    }
  }, [isMailingActive]);

  useEffect(() => {
    setIsMailingActive(mailingActive);
  }, [mailingActive]);

  return (
    <>
      <div className="button-block">
        <TabButton title="Configs" onClick={setActive} active={active} />
        <TabButton title="Mail Contents" onClick={setActive} active={active} />
        <TabButton title="Recipients" onClick={setActive} active={active} />
      </div>
      <NotificationHeader
        selectedNotification={selectedNotification}
        note={getDetailNote(active)}
        toggleProps={{
          show: true,
          text: "Status",
          active: isMailingActive,
          onClick: setIsMailingActive,
        }}
      />
      <div className="mailing__content">
        {active === "Configs" ? (
          <MailingConfigs />
        ) : active === "Mail Contents" ? (
          <MailContents />
        ) : active === "Recipients" ? (
          <MailRecipients />
        ) : null}
        <Backdrop
          spinner={false}
          absolute
          show={!isMailingActive}
          message="Mail notification is inactive! Please click on the status button to activate mail notifications."
          messageStyle={{ paddingTop: 0 }}
        />
      </div>
    </>
  );
};

export default MailNotification;
